// extracted by mini-css-extract-plugin
export var chevron = "_ia-2";
export var dropdownItems = "_ia-0";
export var item = "_ia-1";